// emailid is fetched because this screen exists to control WHERE the
// completion report goes, and it previously showed only the employee's name --
// you could not see the address you were adding, nor spot one that was blank
// or mistyped. (Production has one stored as " backoffice@minumarketing.com",
// with a leading space, which nothing on this screen would have revealed.)
export const emailListQuery =
  `
query allEmailSettion(
    $state: ID,
    $isGlobal: Boolean,
    $after: String
  ){
    allEmailSettings(
      state: $state,
      isGlobal: $isGlobal,
      first: 20,
      after: $after
    ){
        pageInfo{
            endCursor
            hasNextPage
        }
      edges{
        node{
          id
          isGlobal
          employee{
            id
            name
            emailid
          }
          state{
            id
            name
          }
        }
      }
    }
  }
`;
